// src/pages/personal/settings/PlatformPage.tsx
import React from 'react';
import { AdaptiveLayout } from '@/components/ui/Layout';
import PlatformSettingsSection from './PlatformSettingsSection/PlatformSettingsSection';

const PlatformPage: React.FC = () => {
  return (
    <AdaptiveLayout>
      <PlatformSettingsSection />
    </AdaptiveLayout>
  );
};

export default PlatformPage;